<div class="terms-and-conditions-container">
  <app-spacer></app-spacer>
  <span class="title">What do you need to get started?</span>

  <p class="subtitle">
    Registering for +more is super simple! Setting you up for success and more rewards from your
    favourite brands.
  </p>
  <app-spacer></app-spacer>

  <span class="requirements-title">You'll need</span>

  <div class="w-full requirements">
    <div class="requirement">
      <span class="text"
        ><mat-icon class="icon">person_add_alt</mat-icon>Be at least 18 years old</span
      ><mat-icon>check_circle_outline</mat-icon>
    </div>
    <div class="requirement">
      <span class="text"><mat-icon class="icon">fact_check</mat-icon>Valid SA ID or Passport</span
      ><mat-icon>check_circle_outline</mat-icon>
    </div>
    <div class="requirement">
      <span class="text"><mat-icon class="icon">phonelink_ring</mat-icon>SA mobile number</span
      ><mat-icon>check_circle_outline</mat-icon>
    </div>
  </div>

  <app-spacer></app-spacer>

  <div class="w-full terms">
    <span class="terms-description"
      >l accept the Terms and Conditions and give my consent to Pepkor processing my personal
      information according to the Privacy Policy.</span
    >

    <mat-checkbox (change)="termsAccepted.set($event.checked)"></mat-checkbox>
  </div>

  <button class="view-more" (click)="openBottomSheet()">View more</button>

  <app-spacer></app-spacer>

  <div class="w-full button-container">
    <app-cancel-button class="outline-button"></app-cancel-button>
    <app-primary-button
      class="primary-button"
      mat-raised-button
      color="primary"
      [disabled]="!termsAccepted()"
      (click)="nextStep()"
      >Continue</app-primary-button
    >
  </div>
</div>
<p class="version">version: {{ environment.version }}</p>
